import { Injectable } from '@angular/core';
import { TransferConnectV2SettingService } from '@features/transfer-connect-v2/services/transfer-connect-v2-setting/transfer-connect-v2-setting.service';
import { SuccessButton, SuccessButtonGroup } from '@rd/types';

@Injectable()
export class AnzTransferConnectV2SettingService extends TransferConnectV2SettingService {
  shouldDisablePrefilledLinkAccountFields = true;
  shouldPrefillLinkAccountForm = true;
  shouldRenderEnrollmentLinkInCheckoutForm = false;
  hasPromocode = true;

  backToCheckoutPageUrl: (loyaltyProgramId: string) => {
    url: string;
    queryParams?: { [key: string]: string };
  } = (loyaltyProgramId: string) => {
    return {
      url: `/transfer/checkout/${loyaltyProgramId}/membership`,
      queryParams: {
        loyaltyProgramId,
      },
    };
  };

  successButtons(): SuccessButtonGroup {
    const makeAnotherRedemptionButton: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'transfer_v2.success.make_another_redemption',
      buttonTheme: 'primary',
      redirectURL: '/',
    };

    const toPointsTransactionButton: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'transfer_v2.success.see_points_transaction',
      buttonTheme: 'secondary',
      redirectURL: '/points_activity',
    };

    const toMyRedemptions: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'transfer_v2.success.see_my_redemptions',
      buttonTheme: 'primary',
      redirectURL: '/orders',
    };

    const toMoreRewards: SuccessButton = {
      buttonClass: 'full-width-on-mobile flips-on-mobile',
      buttonText: 'transfer_v2.success.make_another_redemption',
      buttonTheme: 'secondary',
      redirectURL: '/',
    };

    return {
      confirmed: [toMoreRewards, toMyRedemptions],
      pending: [
        { ...makeAnotherRedemptionButton, buttonTheme: 'secondary' },
        { ...toMyRedemptions, buttonTheme: 'primary' },
      ],
      failed: [
        { ...makeAnotherRedemptionButton, buttonTheme: 'secondary' },
        { ...toPointsTransactionButton, buttonTheme: 'primary' },
      ],
    };
  }
}
